import * as React from "react";

function Block(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M11 .5C5.2.5.5 5.2.5 11A10.5 10.5 0 0011 21.5c5.798 0 10.5-4.7 10.5-10.5S16.798.5 11 .5zM2.688 11a8.312 8.312 0 0113.58-6.428L4.573 16.268a8.277 8.277 0 01-1.885-5.269zM11 19.31a8.268 8.268 0 01-5.267-1.883L17.43 5.732A8.312 8.312 0 0111 19.31z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoBlock = React.memo(Block);
export default MemoBlock;
